// Geo Fence Location Types

import { DrawRoutesConfig } from './drawRoutes';

export interface GeoFenceLocation {
    latitude: number;
    longitude: number;
    address: string;
    radius: number;  // in meters
    placeId?: string;  // Google Place ID (optional)
}

// Projected Reach configuration
export interface ProjectedReachConfig {
    targetAudience: number;
}

// Updated campaign config to include geo fence, draw routes, and projected reach
export interface CampaignConfig {
    geoFence?: GeoFenceLocation;
    drawRoutes?: DrawRoutesConfig;
    projectedReach?: ProjectedReachConfig;
}

// Default location (San Diego)
export const DEFAULT_LOCATION = {
    latitude: 32.7157,
    longitude: -117.1611
};

// Default radius in meters
export const DEFAULT_RADIUS = 2500;

// Radius limits
export const MIN_RADIUS = 2500;
export const MAX_RADIUS = 10000;
